var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-details"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.getText('ErrorHeader')))]),_c('p',[_vm._v(_vm._s(_vm.getText('ErrorHint')))]),(_vm.error_message !== undefined && _vm.error_message.length > 0)?_c('ErrorMessage',{attrs:{"message":_vm.error_message}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }